import React, { useState } from "react";
import { AlertTriangle, Eraser, Loader2, X } from "lucide-react";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";

/** Admin Finance — danger zone: wipe all transactional test data before launch. */
export default function PurgeTestDataCard() {
  const [open, setOpen] = useState(false);
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);

  const purge = async () => {
    setBusy(true);
    try {
      const { data } = await apiClient.post("/admin/maintenance/purge-test-data", { confirm: word });
      toast.success(`Purge effectuée : ${data.total_deleted} éléments supprimés. Comptabilité remise à zéro.`);
      setTimeout(() => window.location.reload(), 1200);
    } catch (err) {
      toast.error(formatApiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="bg-white border-2 border-brand-red/30 rounded-2xl p-5" data-testid="purge-card">
      <h3 className="font-display text-lg font-semibold text-brand-red inline-flex items-center gap-2">
        <AlertTriangle className="w-4 h-4" /> Zone dangereuse
      </h3>
      <p className="text-sm text-mute mt-1">
        Repartir sur une comptabilité propre avant le lancement officiel : supprime <b>toutes les commandes,
        écritures comptables, reversements, incidents, avis et notifications</b> de test.
        Conserve les comptes, restaurants, menus, candidatures et photos.
      </p>
      <button
        onClick={() => { setWord(""); setOpen(true); }}
        data-testid="purge-open-btn"
        className="mt-3 inline-flex items-center gap-2 rounded-full border border-brand-red text-brand-red hover:bg-brand-red hover:text-white px-4 py-2 text-sm font-semibold"
      >
        <Eraser className="w-4 h-4" /> Purger les données de test
      </button>

      {open && (
        <div className="fixed inset-0 z-[60] bg-black/50 grid place-items-center p-4" data-testid="purge-modal">
          <div className="bg-white rounded-2xl w-full max-w-md p-6 relative">
            <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-mute hover:text-ink" data-testid="purge-modal-close" aria-label="Fermer">
              <X className="w-5 h-5" />
            </button>
            <h3 className="font-display text-lg font-semibold mb-2 text-brand-red">Confirmer la purge totale</h3>
            <div className="text-sm space-y-2 mb-4">
              <div className="bg-brand-red/10 rounded-xl p-3">
                <b>Sera supprimé (irréversible) :</b> commandes, grand livre, reversements, échecs express,
                incidents, régularisations MoMo, avis, notifications, alertes rupture, points de fidélité.
              </div>
              <div className="bg-[#E7F6EE] rounded-xl p-3">
                <b>Sera conservé :</b> comptes (clients, restaurants, livreurs, admin), restaurants et menus,
                candidatures, photos, abonnements aux alertes.
              </div>
            </div>
            <label className="text-xs text-mute">Tapez <b className="text-brand-red">PURGER</b> pour confirmer :</label>
            <input
              value={word}
              onChange={(e) => setWord(e.target.value.toUpperCase())}
              data-testid="purge-confirm-input"
              placeholder="PURGER"
              className="mt-1 w-full rounded-xl border border-sand px-3 py-2.5 text-sm font-semibold tracking-widest"
            />
            <button
              onClick={purge}
              disabled={busy || word !== "PURGER"}
              data-testid="purge-confirm-btn"
              className="mt-3 w-full rounded-xl bg-brand-red hover:bg-[#C21E2C] disabled:opacity-40 text-white py-3 text-sm font-semibold inline-flex items-center justify-center gap-2"
            >
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Eraser className="w-4 h-4" />} Purger définitivement
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
